import { createSlice } from "@reduxjs/toolkit";

const promoCodesSlice = createSlice({
  name: "promoCodes",
  initialState: {
    promoCodes: [],
    selectedPromoCode: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      totalPages: 1,
      total: 0,
    },
  },
  reducers: {
    setPromoCodes: (state, action) => {
      state.promoCodes = action.payload;
    },
    addPromoCode: (state, action) => {
      state.promoCodes.unshift(action.payload);
    },
    updatePromoCode: (state, action) => {
      const index = state.promoCodes.findIndex((p) => p._id === action.payload._id);
      if (index !== -1) {
        state.promoCodes[index] = action.payload;
      }
    },
    deletePromoCode: (state, action) => {
      state.promoCodes = state.promoCodes.filter((p) => p._id !== action.payload);
    },
    setSelectedPromoCode: (state, action) => {
      state.selectedPromoCode = action.payload;
    },
    setPromoCodesLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPromoCodesError: (state, action) => {
      state.error = action.payload;
    },
    setPromoCodesPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearPromoCodesState: (state) => {
      state.promoCodes = [];
      state.selectedPromoCode = null;
      state.loading = false;
      state.error = null;
      state.pagination = { page: 1, totalPages: 1, total: 0 };
    },
  },
});

export const {
  setPromoCodes,
  addPromoCode,
  updatePromoCode,
  deletePromoCode,
  setSelectedPromoCode,
  setPromoCodesLoading,
  setPromoCodesError,
  setPromoCodesPagination,
  clearPromoCodesState,
} = promoCodesSlice.actions;

export default promoCodesSlice.reducer;
